import { render, staticRenderFns } from "./GraficoBar.vue?vue&type=template&id=63e0d8a2&scoped=true"
import script from "./GraficoBar.vue?vue&type=script&lang=js"
export * from "./GraficoBar.vue?vue&type=script&lang=js"
import style0 from "./GraficoBar.vue?vue&type=style&index=0&id=63e0d8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0d8a2",
  null
  
)

export default component.exports